import axios from "../axiosInstance";
import { EmployeeSearchConfig } from "./types";

export const getEmployeeSearchConfig =
  async (): Promise<EmployeeSearchConfig> => {
    const response = await axios.get<EmployeeSearchConfig>(
      `/api/search/config/employees`,
    );
    return response.data;
  };
